var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service",on:{"click":_vm.contactSeller}},[_c('img',{staticClass:"service-img",attrs:{"src":require("@/assets/common/kefu_icon@2x.png")}}),_c('span',{staticClass:"service-text"},[_vm._v(_vm._s(_vm.orderType === 1 ? "联系卖家" : "联系买家"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }